/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSON, FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimes';
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions(value) {
    return true;
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PlayUrl': json['PlayUrl'] == null ? undefined : json['PlayUrl'],
        'Runtimes': json['Runtimes'] == null ? undefined : FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesFromJSON(json['Runtimes']),
    };
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PlayUrl': value['PlayUrl'],
        'Runtimes': FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsRuntimesToJSON(value['Runtimes']),
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptions.js.map